module.exports = __webpack_public_path__ + "static/img/3bg_6.4d3cb91.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/3bg_6.png
// module id = 690
// module chunks = 1